import { Component } from '@angular/core';

@Component({
  selector: 'app-card-product-navigation',
  templateUrl: './post-card-product-navigation.component.html',
})
export class PostCardProductNavigationComponent {}
